// Importing with this method lazy loads the route. Better for performance
import { authGuard } from '@auth0/auth0-vue'

const BillingView = () => import('@/Billing/BillingView.vue')
const AuthenticateView = () => import('@/Billing/views/AuthenticateView.vue')
const SelectPlanView = () => import('@/Billing/views/SelectPlanView.vue')
const SelectSupportView = () => import('@/Billing/views/SelectSupportView.vue')
const SetupSiteView = () => import('@/Billing/views/SetupSiteView.vue')
const PaymentView = () => import('@/Billing/views/PaymentView.vue')
const ManageSubscriptionView = () => import('@/Billing/views/ManageSubscriptionView.vue')

const routes = [
  {
    path: '/billing',
    name: 'billing',
    component: BillingView,
    redirect: to => {
      return { name: 'billingLogin' }
    },
    children: [
      {
        path: 'authenticate',
        name: 'authenticate',
        component: AuthenticateView,
        beforeEnter: authGuard
      },
      {
        path: 'select-plan',
        name: 'selectPlan',
        component: SelectPlanView,
        beforeEnter: authGuard
      },
      {
        path: 'select-support',
        name: 'selectSupport',
        component: SelectSupportView,
        beforeEnter: authGuard
      },
      {
        path: 'setup-site',
        name: 'setupSite',
        component: SetupSiteView,
        beforeEnter: authGuard
      },
      {
        path: 'manage-subscription',
        name: 'manageSubscription',
        component: ManageSubscriptionView,
        beforeEnter: authGuard
      },
      {
        path: 'payment',
        name: 'payment',
        component: PaymentView,
        beforeEnter: authGuard
      }
    ]
  }
]

export default routes
